import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiNameInputComponent } from './fi-name-input.component';
import { MatInputModule } from '@angular/material/input';
import { FiAppTextSharedModule } from '../app-text';
import { FormsModule } from '@angular/forms';
import { InfoIconModule } from '../info-icon/info-icon.module';
import { MatIconModule } from '@angular/material/icon';
import { FiDirectivesModule } from '../fi-directives/fi-directives.module';

@NgModule({
    imports: [CommonModule, MatInputModule, FiAppTextSharedModule, FormsModule, InfoIconModule, MatIconModule, FiDirectivesModule],
    declarations: [FiNameInputComponent],
    exports: [FiNameInputComponent],
})
export class FiNameInputModule {}